export const state = {
    isAuth: false,
    user: false,
    user_load: false,
    show_login: false,
    currentUser: sessionStorage.getItem('authUser'),
}

export const mutations = {
    setShowLogin(state, value) {
        state.show_login = value
    },
    setAuth(state, value) {
        state.isAuth = value
    },
    setUser(state, value) {
        state.user_load = true
        state.user = value
    },
    SET_CURRENT_USER(state, user) {
        if (user) {
            var newValue = {
                "_id": user.id,
                "first_name": user.first_name,
                "last_name": user.last_name,
                "name": user.name,
                "email": user.email,
                "phone": user.phone,
                "image": "",
                "role": "0",
                "confirm_password": "123456789",
                "changePasswordAt": "2023-02-13T04:32:11.228Z",
                "skills": ["Photoshop", "illustrator", "HTML", "CSS", "Javascript", "Php", "Python"],
                "exp_year": '',
                "city": "",
                "company_name": "",
                "country": "",
                "designation": "designation",
                "job_title": "Developer",
                "joining_date": "2023-01-01T00:00:00.000Z",
                "website": "",
                "zipcode": "",
                "description": "",
                "job_description": "job_description",
                "portfolio": [],
            };

            state.currentUser = newValue

            saveState('auth.currentUser', newValue)
        }
    }
}

export const getters = {
    isAuth(state) {
        return state.isAuth
    },
    user(state) {
        return state.user
    },
    user_load(state) {
        return state.user_load
    },
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.currentUser
    },
    show_login(state){
        return state.show_login
    }
}

export const actions = {
    async tryAuth({dispatch}, ctx = null) {
        let result = await this.$api.auth.auth(ctx)
        var answer = result.data
        await dispatch('after_login', answer);
        return result
    },
    async after_login({commit}, user = null) {
        if (user && user.id) {
            if (user.self) {
                user.phone = user.self;
            }
            commit('setUser', user)
            // commit('SET_CURRENT_USER', user)
            commit('setAuth', true)
        } else {
            commit('setUser', {})
            // commit('SET_CURRENT_USER', {})
            commit('setAuth', false)
        }
        return user
    },
    setShowLogin({commit}, value = true) {
        commit('setShowLogin', value)
    },
    async getMe({dispatch}) {
        var user = []
        try {
            const response = await this.$api.auth.me();
            user = response.data;
        } catch (e) {
            console.log(e)
        }
        await dispatch('after_login', user);

        return user
    },

    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        dispatch('validate')
    },


    async Logout({commit}, ctx = null) {
        const response = await this.$api.auth.Logout(ctx);

        if (typeof response.success !== 'undefined' && response.success) {
            commit('setUser', false);
            commit('setAuth', false);
        }

        return response;
    },

}

// ===
// Private helpers
// ===

function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}
